import { unsafeCSS as u, LitElement as k, html as w } from "lit";
import { property as d } from "lit/decorators.js";
import { classMap as b } from "lit/directives/class-map.js";
const x = (i) => {
  class e extends i {
    constructor(...n) {
      super(...n), this.fontLink = "https://www.aa.com/fonts/css?family=american-sans-variable";
      const a = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(a.getElementsByTagName("link")).findIndex(
        (c) => c.href === this.fontLink
      ) === -1) {
        const c = document.createElement("link");
        c.href = this.fontLink, c.rel = "stylesheet", document.head.appendChild(c);
      }
    }
  }
  return e;
}, y = `*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.static{position:static}.absolute{position:absolute}.relative{position:relative}.left-0{left:0}.left-\\[initial\\]{left:initial}.left-full{left:100%}.right-0{right:0}.right-full{right:100%}.top-0{top:0}.block{display:block}.inline{display:inline}.inline-flex{display:inline-flex}.h-6{height:1.5rem}.w-5{width:1.25rem}.flex-row-reverse{flex-direction:row-reverse}.items-center{align-items:center}.rounded{border-radius:.25rem}.bg-blue-060{background-color:#0860c4}.bg-green-060{background-color:#316833}.bg-neutral-060{background-color:#50657c}.bg-neutral-120{background-color:#f3f5f7}.bg-orange-060{background-color:#ae3f13}.bg-red-060{background-color:#cd1d32}.px-1{padding-left:.25rem;padding-right:.25rem}.py-0{padding-top:0;padding-bottom:0}.py-0\\.5{padding-top:.125rem;padding-bottom:.125rem}.pl-0{padding-left:0}.pl-4{padding-left:1rem}.pr-4{padding-right:1rem}.font-sans{font-family:AmericanSans Var,Helvetica,Arial,sans-serif}.text-sm{font-size:.875rem}.text-xs{font-size:.75rem}.uppercase{text-transform:uppercase}.leading-4{line-height:1rem}.leading-5{line-height:1.25rem}.text-neutral-000{color:#101419}.text-neutral-140{color:#fff}.font-medium{font-weight:500;font-variation-settings:"wght" 500}[hidden]{display:none!important}.after\\:absolute:after{content:var(--tw-content);position:absolute}.after\\:left-\\[initial\\]:after{content:var(--tw-content);left:initial}.after\\:left-full:after{content:var(--tw-content);left:100%}.after\\:right-full:after{content:var(--tw-content);right:100%}.after\\:top-0:after{content:var(--tw-content);top:0}.after\\:block:after{content:var(--tw-content);display:block}.after\\:h-6:after{content:var(--tw-content);height:1.5rem}.after\\:w-5:after{content:var(--tw-content);width:1.25rem}.after\\:bg-blue-060:after{content:var(--tw-content);background-color:#0860c4}.after\\:bg-green-060:after{content:var(--tw-content);background-color:#316833}.after\\:bg-neutral-060:after{content:var(--tw-content);background-color:#50657c}.after\\:bg-neutral-120:after{content:var(--tw-content);background-color:#f3f5f7}.after\\:bg-orange-060:after{content:var(--tw-content);background-color:#ae3f13}.after\\:bg-red-060:after{content:var(--tw-content);background-color:#cd1d32}
`, R = u(y), g = "aileron-color-scheme", m = "aileron-color-scheme-change", E = (i) => {
  class e extends i {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (n) => {
        n.detail ? this.setAttribute(g, n.detail) : this.removeAttribute(g);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        m,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const n = document.documentElement.getAttribute(
        g
      );
      n && this.setAttribute(g, n);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        m,
        this.handleSchemeSwitch
      );
    }
  }
  return e.styles = [
    R,
    i.styles ?? []
  ], e;
}, v = E(x(k)), B = `:host{--ribbon-ltr: url("data:image/svg+xml,%3Csvg width='20' height='24' viewBox='0 0 20 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.224 15.8835L20 0.000922377L0 0V24C3.17767 23.5418 7.90462 21.8819 11.224 15.8835Z' fill='currentcolor' /%3E%3C/svg%3E%0A");--ribbon-rtl: url("data:image/svg+xml,%3Csvg width='20' height='24' viewBox='0 0 20 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.776 15.8835L0 0.000922377L20 0V24C16.8223 23.5418 12.0954 21.8819 8.776 15.8835Z' fill='currentcolor'/%3E%3C/svg%3E%0A");display:inline-flex}:host ::slotted(*){display:flex;align-self:center}::slotted([slot="icon"]){padding-right:.25rem}:host([position="rtl"]) ::slotted([slot="icon"]){padding-left:.25rem;padding-right:0}:host([variant="ribbon"]) .adc-tag:after{-webkit-mask-image:var(--ribbon-ltr);mask-image:var(--ribbon-ltr);content:" "}:host([variant="ribbon"][position="rtl"]) .adc-tag:after{-webkit-mask-image:var(--ribbon-rtl);mask-image:var(--ribbon-rtl);content:" "}
`;
var A = Object.defineProperty, L = Object.getOwnPropertyDescriptor, h = (i, e, l, n) => {
  for (var a = n > 1 ? void 0 : n ? L(e, l) : e, p = i.length - 1, f; p >= 0; p--)
    (f = i[p]) && (a = (n ? f(e, l, a) : f(a)) || a);
  return n && a && A(e, l, a), a;
};
const r = {
  SUCCESS: "success",
  INFO: "information",
  WARNING: "warning",
  ERROR: "error",
  DEFAULT: "default",
  DARKER_DEFAULT: "default-dark"
}, t = {
  RIBBON: "ribbon",
  DEFAULT: ""
}, o = {
  RTL: "rtl",
  LTR: "ltr"
};
class s extends v {
  constructor() {
    super(...arguments), this.position = o.LTR, this.kind = r.DEFAULT, this.variant = t.DEFAULT, this.small = !1;
  }
  render() {
    const { labelText: e } = this;
    return w`<div
      part="tag"
      class="adc-tag items-center text-neutral-000 inline-flex py-0.5 px-1 relative ${b(
      {
        rounded: this.variant !== t.RIBBON,
        "text-neutral-140": this.kind !== r.DEFAULT,
        "bg-neutral-120": this.kind === r.DEFAULT,
        "bg-neutral-060": this.kind === r.DARKER_DEFAULT,
        "bg-green-060": this.kind === r.SUCCESS,
        "bg-blue-060": this.kind === r.INFO,
        "bg-orange-060": this.kind === r.WARNING,
        "bg-red-060": this.kind === r.ERROR,
        "flex-row-reverse": this.position === o.RTL,
        "left-0": this.variant === t.RIBBON,
        "pl-4": this.variant === t.RIBBON,
        absolute: this.variant === t.RIBBON,
        "left-[initial]": this.variant === t.RIBBON && this.position === o.RTL,
        "right-0": this.variant === t.RIBBON && this.position === o.RTL,
        "pl-0": this.variant === t.RIBBON && this.position === o.RTL,
        "pr-4": this.variant === t.RIBBON && this.position === o.RTL,
        "after:block": this.variant === t.RIBBON,
        "after:h-6": this.variant === t.RIBBON,
        "after:left-full": this.variant === t.RIBBON && this.position === o.LTR,
        "after:absolute": this.variant === t.RIBBON,
        "after:top-0": this.variant === t.RIBBON,
        "after:w-5": this.variant === t.RIBBON,
        "after:left-[initial]": this.variant === t.RIBBON && this.position === o.RTL,
        "after:right-full": this.variant === t.RIBBON && this.position === o.RTL,
        "after:bg-neutral-120": this.kind === r.DEFAULT,
        "after:bg-neutral-060": this.kind === r.DARKER_DEFAULT,
        "after:bg-green-060": this.kind === r.SUCCESS,
        "after:bg-blue-060": this.kind === r.INFO,
        "after:bg-orange-060": this.kind === r.WARNING,
        "after:bg-red-060": this.kind === r.ERROR
      }
    )}"
    >
      <slot name="icon"></slot>
      ${e ? w`<span
            class="font-sans font-medium uppercase ${b({
      "text-sm": !this.small,
      "text-xs": this.small,
      "leading-5": !this.small,
      "leading-4": this.small
    })}"
            >${e}</span
          >` : ""}
    </div> `;
  }
  /**
   * Adds the a11y role to the tag.
   */
  connectedCallback() {
    this.classList.add("adc-tag"), super.connectedCallback(), this.getAttribute("role") || this.setAttribute("role", "region");
  }
}
s.styles = [v.styles || [], u(B)];
h([
  d({ type: String, attribute: "label-text" })
], s.prototype, "labelText", 2);
h([
  d({ type: String, reflect: !0 })
], s.prototype, "position", 2);
h([
  d({ type: String, reflect: !0 })
], s.prototype, "kind", 2);
h([
  d({ type: String, reflect: !0 })
], s.prototype, "variant", 2);
h([
  d({ type: Boolean, reflect: !0 })
], s.prototype, "small", 2);
try {
  customElements.define("adc-tag", s);
} catch {
}
function T(i) {
  try {
    customElements.define(`${i}-tag`, class extends s {
    });
  } catch {
  }
}
function C(i) {
  try {
    T(i);
  } catch {
  }
}
export {
  r as TAG_KIND,
  o as TAG_POSITION,
  t as TAG_VARIANT,
  s as Tag,
  C as registerComponent,
  T as registerTag
};
